import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  width: (p) => p.spacing(21.5),
  display: 'flex',
  flexDirection: 'column',
};

export const buttonGroup: SxStyle = {
  height: (p) => p.spacing(4),
};
